// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-content[data-v-e057f124] {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.label-content .content[data-v-e057f124] {
  width: 100%;
  flex: 1;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/RegionalQuota/ImportQuota.vue","webpack://./ImportQuota.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADLA;EAOI,WAAA;EACA,OAAA;EACA,gBAAA;ACCJ","sourcesContent":["\n.label-content {\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .content {\n    width: 100%;\n    flex: 1;\n    overflow: hidden;\n  }\n}\n",".label-content {\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.label-content .content {\n  width: 100%;\n  flex: 1;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
